import router from './router'
router.beforeEach((to, from, next) => {
    console.log(111, to, from, next)
    // if (to.fullPath.includes('404')) {
    next()
    // } else {
    //     next('/404')
    // }
})
